import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext';
import { Dashboard } from '../analytics/Dashboard';
import { HealthStatus } from './HealthStatus';

/** Startseite: Begrüßung, Dashboard der Auswertungen und Systemstatus. */
export function HomePage() {
  const { t } = useTranslation();
  const { user } = useAuth();
  return (
    <section>
      <h1>{t('home.title')}</h1>
      {user && <p>{t('home.greeting', { name: user.username })}</p>}
      <Dashboard />
      <h2>{t('health.title')}</h2>
      <HealthStatus />
    </section>
  );
}
